// extracted by mini-css-extract-plugin
module.exports =  {"paper":"style-module_paper__zyK66tVn6rKUtb_FNKZw"};